<template>
  <div class="animated fadeIn accelerator-requests" v-if="pageLoaded">
    <b-card style="border: 0" class="common-card mt-0 mb-0">
      <h3>کد فرصت مطالعاتی: {{ proposal.requestsCode }}</h3>
      <h4 class="text-dark">وضعیت فرصت مطالعاتی: {{ proposal.status }}</h4>
      <hr />
      <v-card class="common-card card-shadow pa-0 mb-4">
        <v-card-title class="warning ma-0">
          <v-icon class="pe-2 black--text">mdi-email-receive-outline</v-icon>
          پیام مدیر
        </v-card-title>
        <v-card-text class="c-grey pt-4">
          {{ this.proposal.adminToReferee }}
        </v-card-text>
      </v-card>
      <v-btn
        class="float-end bc-purple"
        v-if="tabIndex == 0"
        @click="saveDocx('doc')"
        elevation="0"
      >
        <i class="fa fa-file-word-o white--text pe-2"></i>
        <span class="white--text text-capitalize">دریافت Word</span>
      </v-btn>

      <!-- docx -->
      <div v-show="false" id="doc">
        <div class="all" style="text-align: right">
          <h1
            style="
              display: inline-block;
              text-align: center;
              padding: 5px 0;
              border-bottom: 3px solid black;
            "
          >
            کد فرصت مطالعاتی:
            <span style="direction: ltr; font-family: Bahnschrift SemiBold">{{
              proposal.requestsCode
            }}</span>
          </h1>
          <div>
            <h2 style="color: black">
              تاریخ خروجی:
              <span style="direction: ltr">{{ proposal.registerDate }}</span>
            </h2>
            <hr />
            <h2 style="display: inline-block; text-align: center; color: blue">
              عنوان و حمایت‌های پیشین
            </h2>
            <div>
              <ul>
                <li :class="proposal.faSubject ? 'done' : 'required'">
                  <strong>عنوان دقیق دوره: </strong>{{ proposal.faSubject }}
                </li>
                <li
                  :class="
                    proposal.initialIsSupported != null ? 'done' : 'required'
                  "
                >
                  <strong
                    >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده
                    کرده است؟
                  </strong>

                  {{ proposal.initialIsSupported ? "بله" : "خیر" }}
                </li>

                <li
                  v-if="proposal.initialIsSupported"
                  :class="proposal.initialSupportedType ? 'done' : 'required'"
                >
                  <strong> حمایت ها: </strong
                  >{{
                    proposal.initialSupportedType
                      ? options.filter(
                          (x) => x.value == proposal.initialSupportedType
                        )[0].text
                      : ""
                  }}
                </li>
                <li
                  v-if="
                    proposal.initialSupportedType == 'other' &&
                    proposal.initialIsSupported
                  "
                  :class="proposal.initialOtherSupport ? 'done' : 'required'"
                >
                  <strong>عنوان حمایت دریافتی: </strong>
                  {{ proposal.initialOtherSupport }}
                </li>
                <li
                  v-if="proposal.initialIsSupported"
                  :class="
                    proposal.initialSupportDescription ? 'done' : 'required'
                  "
                >
                  <strong>توضیحات حمایت دریافتی: </strong>
                  {{ proposal.initialSupportDescription }}
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              اطلاعات اصلی دوره
            </h2>
            <div>
              <ul>
                <li :class="proposal.faSubject ? 'done' : 'required'">
                  <strong>عنوان به زبان فارسی: </strong>{{ proposal.faSubject }}
                </li>
                <li :class="proposal.enSubject ? 'done' : 'required'">
                  <strong>عنوان به زبان انگلیسی: </strong
                  >{{ proposal.enSubject }}
                </li>
                <li :class="proposal.universityId ? 'done' : 'required'">
                  <strong>دانشگاه محل اجرای دوره: </strong>
                  {{
                    proposal.universityId
                      ? universities.filter(
                          (x) => x.id == proposal.universityId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.universityId
                          )[0].text
                        : ""
                      : ""
                  }}
                </li>
                <li
                  v-if="proposal.universityId == notUniversity"
                  :class="proposal.otherUniversity ? 'done' : 'required'"
                >
                  <strong>نام دانشگاه: </strong>{{ proposal.otherUniversity }}
                </li>
                <li
                  v-if="proposal.mehvarId != notMehvar"
                  :class="proposal.mehvarId ? 'done' : 'required'"
                >
                  <strong>محور دوره: </strong>
                  {{
                    proposal.mehvarId
                      ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                        ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                            .text
                        : ""
                      : ""
                  }}
                </li>
                <li
                  v-if="proposal.mehvarId == notMehvar"
                  :class="proposal.mehvarId ? 'done' : 'required'"
                >
                  <strong>محور دوره: </strong> سایر محورها
                </li>
                <li
                  v-if="proposal.mehvarId == notMehvar"
                  :class="proposal.otherMehvars ? 'done' : 'required'"
                >
                  <strong>نام محور: </strong>{{ proposal.otherMehvars }}
                </li>
                <li>
                  <strong>ماهیت دوره: </strong>
                  <ul>
                    <li v-if="proposal.typeStudy">مطالعاتی</li>
                    <li v-if="proposal.typeSystemicDevelopmental">
                      سیستمی و توسعه‌ای
                    </li>
                    <li v-if="proposal.typePractical">کاربردی</li>
                  </ul>
                </li>
                <li>
                  <strong>حوزه دوره: </strong>
                  <ul>
                    <li v-if="proposal.zoneMedicine">پزشکی</li>
                    <li v-if="proposal.zoneAgriculture">کشاورزی</li>
                    <li v-if="proposal.zoneEnvironment">محیط زیست</li>
                    <li v-if="proposal.zoneIndustrial">صنعتی</li>
                    <li v-if="proposal.zoneBioComputing">رایانش زیستی</li>
                    <li v-if="proposal.zoneOther">سایر</li>
                  </ul>
                </li>
                <li :class="proposal.oppurtunityActions ? 'done' : 'required'">
                  <strong>
                    گزارش خلاصه اقداماتی که قصد دارید در دانشگاه مقصد در طی دوره
                    انجام دهید: </strong
                  ><br />{{ proposal.oppurtunityActions }}
                </li>
                <br />
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.oppurtunityAchievements"
                  :fields="achievmentFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                </b-table>
              </ul>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              اطلاعات متقاضی
            </h2>
            <div>
              <ul>
                <li :class="proposal.researcherName ? 'done' : 'required'">
                  <strong>نام: </strong>{{ proposal.researcherName }}
                </li>

                <li :class="proposal.researcherLastName ? 'done' : 'required'">
                  <strong>نام خانوادگی: </strong
                  >{{ proposal.researcherLastName }}
                </li>
                <li :class="proposal.researcherNatCode ? 'done' : 'required'">
                  <strong>کدملی: </strong>{{ proposal.researcherNatCode }}
                </li>
                <li :class="proposal.researcherMobile ? 'done' : 'required'">
                  <strong>تلفن همراه: </strong>{{ proposal.researcherMobile }}
                </li>
                <li :class="proposal.researcherFax ? 'done' : 'required'">
                  <strong>دورنگار: </strong>{{ proposal.researcherFax }}
                </li>
                <li :class="proposal.researcherEmail ? 'done' : 'required'">
                  <strong>پست الکترونیکی: </strong
                  >{{ proposal.researcherEmail }}
                </li>
                <li :class="proposal.researcherState ? 'done' : 'required'">
                  <strong>استان: </strong>{{ proposal.researcherState }}
                </li>
                <li :class="proposal.researcherCity ? 'done' : 'required'">
                  <strong>شهر: </strong>{{ proposal.researcherCity }}
                </li>
                <li
                  :class="proposal.researcherUniversityId ? 'done' : 'required'"
                >
                  <strong>دانشگاه محل تحصیل: </strong>
                  {{
                    proposal.researcherUniversityId
                      ? universities.filter(
                          (x) => x.id == proposal.researcherUniversityId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.researcherUniversityId
                          )[0].text
                        : "-"
                      : "-"
                  }}
                </li>
                <li
                  :class="
                    proposal.researcherUniversityOther ? 'done' : 'required'
                  "
                  v-if="proposal.researcherUniversityId == notUniversity"
                >
                  <strong>نام دانشگاه: </strong
                  >{{ proposal.researcherUniversityOther }}
                </li>
                <li class="'done'">
                  <strong>دانشگاه محل اشتغال: </strong>
                  {{
                    proposal.researcherUniversityJobId
                      ? universities.filter(
                          (x) => x.id == proposal.researcherUniversityJobId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.researcherUniversityJobId
                          )[0].text
                        : "-"
                      : "-"
                  }}
                </li>
                <li v-if="proposal.researcherUniversityJobId == notUniversity">
                  <strong>نام دانشگاه: </strong
                  >{{ proposal.researcherUniversityJobOther }}
                </li>
                <li :class="proposal.researcherIBAN ? 'done' : 'required'">
                  <strong>شماره شبا: </strong>{{ proposal.researcherIBAN }}
                </li>
                <li :class="proposal.researcherBankName ? 'done' : 'required'">
                  <strong>نام بانک: </strong>{{ proposal.researcherBankName }}
                </li>
                <li
                  :class="
                    proposal.researcherUniversityDestination
                      ? 'done'
                      : 'required'
                  "
                >
                  <strong>دانشگاه مقصد: </strong
                  >{{ proposal.researcherUniversityDestination }}
                </li>
                <li
                  :class="
                    proposal.researcherCountryDestination ? 'done' : 'required'
                  "
                >
                  <strong>کشور مقصد: </strong
                  >{{ proposal.researcherCountryDestination }}
                </li>
                <li v-if="proposal.researcherMasterStudent == 'master'">
                  <strong>شاخص Hindex استاد: </strong
                  >{{ proposal.researcherHindex }}
                </li>
                <li v-if="proposal.researcherMasterStudent == 'student'">
                  <strong>شاخص Hindex دانشجو: </strong
                  >{{ proposal.researcherHindex }}
                </li>
                <li v-if="proposal.researcherMasterStudent == 'student'">
                  <strong>نمره امتحان جامع دانشجو: </strong
                  >{{ proposal.researcherComprehensiveTestMark }}
                </li>
                <li v-if="proposal.researcherMasterStudent == 'student'">
                  <strong>تاریخ امتحان جامع دانشجو: </strong
                  ><span style="direction: ltr">{{
                    proposal.researcherComprehensiveTestDate
                  }}</span>
                </li>
                <li
                  :class="
                    proposal.researcherPhDThesisSubject ? 'done' : 'required'
                  "
                >
                  <strong>عنوان طرح رساله دکتری: </strong
                  >{{ proposal.researcherPhDThesisSubject }}
                </li>
                <li
                  v-if="proposal.researcherMasterStudent == 'student'"
                  :class="
                    proposal.researcherPhDThesisDefenceDate
                      ? 'done'
                      : 'required'
                  "
                >
                  <strong>تاریخ تصویب رساله: </strong
                  ><span style="direction: ltr">{{
                    proposal.researcherPhDThesisDefenceDate
                  }}</span>
                </li>
                <br />
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.researcherArticleISI"
                  :fields="articlesFieldsDoc"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                </b-table>
              </ul>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              اطلاعات اساتید
            </h2>
            <div>
              <strong style="color: blue">استاد راهنمای داخلی</strong>
              <ul>
                <li :class="proposal.supervisors[0].name ? 'done' : 'required'">
                  <strong>نام: </strong>{{ proposal.supervisors[0].name }}
                </li>
                <li
                  :class="
                    proposal.supervisors[0].lastName ? 'done' : 'required'
                  "
                >
                  <strong>نام خانوادگی: </strong
                  >{{ proposal.supervisors[0].lastName }}
                </li>
                <li
                  :class="proposal.supervisors[0].natCode ? 'done' : 'required'"
                >
                  <strong>کدملی: </strong>{{ proposal.supervisors[0].natCode }}
                </li>
                <li
                  :class="proposal.supervisors[0].mobile ? 'done' : 'required'"
                >
                  <strong>تلفن همراه: </strong
                  >{{ proposal.supervisors[0].mobile }}
                </li>

                <li
                  :class="proposal.supervisors[0].email ? 'done' : 'required'"
                >
                  <strong>پست الکترونیکی: </strong
                  >{{ proposal.supervisors[0].email }}
                </li>
                <li
                  :class="
                    proposal.supervisors[0].position ? 'done' : 'required'
                  "
                >
                  <strong>سمت: </strong>{{ proposal.supervisors[0].position }}
                </li>
                <li
                  :class="
                    proposal.supervisors[0].universityId ? 'done' : 'required'
                  "
                >
                  <strong>دانشگاه محل تحصیل: </strong>
                  {{
                    universities.filter(
                      (x) => x.id == proposal.supervisors[0].universityId
                    ).length
                      ? universities.filter(
                          (x) => x.id == proposal.supervisors[0].universityId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.supervisors[0].universityId
                          )[0].text
                        : ""
                      : ""
                  }}
                </li>
                <li
                  v-if="proposal.supervisors[0].universityId == notUniversity"
                  :class="
                    proposal.supervisors[0].universityOther
                      ? 'done'
                      : 'required'
                  "
                >
                  <strong>نام دانشگاه: </strong
                  >{{ proposal.supervisors[0].universityOther }}
                </li>
                <li
                  :class="
                    proposal.supervisors[0].universityJobId
                      ? 'done'
                      : 'required'
                  "
                >
                  <strong>دانشگاه محل اشتغال: </strong>
                  {{
                    proposal.supervisors[0].universityJobId
                      ? universities.filter(
                          (x) => x.id == proposal.supervisors[0].universityJobId
                        )[0]
                        ? universities.filter(
                            (x) =>
                              x.id == proposal.supervisors[0].universityJobId
                          )[0].text
                        : "-"
                      : "-"
                  }}
                </li>
                <li
                  v-if="
                    proposal.supervisors[0].universityJobId == notUniversity
                  "
                  :class="
                    proposal.supervisors[0].universityJobOther
                      ? 'done'
                      : 'required'
                  "
                >
                  <strong>نام دانشگاه: </strong
                  >{{ proposal.supervisors[0].universityJobOther }}
                </li>
                <hr />
                <strong style="color: blue">استاد راهنمای خارجی</strong>
                <li :class="proposal.advisors[0].name ? 'done' : 'required'">
                  <strong>نام: </strong>{{ proposal.advisors[0].name }}
                </li>
                <li
                  :class="proposal.advisors[0].lastName ? 'done' : 'required'"
                >
                  <strong>نام خانوادگی: </strong
                  >{{ proposal.advisors[0].lastName }}
                </li>
                <li :class="proposal.advisors[0].mobile ? 'done' : 'required'">
                  <strong>تلفن همراه: </strong>{{ proposal.advisors[0].mobile }}
                </li>

                <li :class="proposal.advisors[0].email ? 'done' : 'required'">
                  <strong>پست الکترونیکی: </strong
                  >{{ proposal.advisors[0].email }}
                </li>
                <li
                  :class="proposal.advisors[0].position ? 'done' : 'required'"
                >
                  <strong>سمت: </strong>{{ proposal.advisors[0].position }}
                </li>
                <li
                  :class="
                    proposal.advisors[0].universityOther ? 'done' : 'required'
                  "
                >
                  <strong>دانشگاه محل تحصیل: </strong>
                  {{ proposal.advisors[0].universityOther }}
                </li>
                <li
                  :class="proposal.advisors[0].lastDegree ? 'done' : 'required'"
                >
                  <strong>آخرین مدرک تحصیلی: </strong>
                  {{ proposal.advisors[0].lastDegree }}
                </li>
                <li
                  :class="
                    proposal.advisors[0].universityJobOther
                      ? 'done'
                      : 'required'
                  "
                >
                  <strong>دانشگاه محل اشتغال: </strong>
                  {{ proposal.advisors[0].universityJobOther }}
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              اطلاعات تجاری‌سازی
            </h2>
            <h4 style="font-size: 18px">
              نوع تجاری‌سازی:
              {{
                proposal.commercializingType == "company"
                  ? "شرکت دانش بنیان"
                  : proposal.commercializingType == "accelerator"
                  ? "شتاب‌دهنده"
                  : "فاقد اطلاعات تجاری‌سازی می‌باشد"
              }}
            </h4>
            <div v-if="proposal.commercializingType == 'company'">
              <ul>
                <div v-if="proposal.companyId != notCompany">
                  <li :class="proposal.companyName ? 'done' : 'required'">
                    <strong>نام شرکت دانش بنیان: </strong
                    >{{ proposal.companyName }}
                  </li>
                  <li
                    :class="
                      proposal.companyRegistrationNumber ? 'done' : 'required'
                    "
                  >
                    <strong>شماره ثبت شرکت: </strong
                    >{{ proposal.companyRegistrationNumber }}
                  </li>
                  <li :class="proposal.companyNationalId ? 'done' : 'required'">
                    <strong>شناسه ملی شرکت: </strong
                    >{{ proposal.companyNationalId }}
                  </li>
                </div>
                <div v-else>
                  <li :class="proposal.otherCompanyName ? 'done' : 'required'">
                    <strong>نام شرکت دانش بنیان: </strong
                    >{{ proposal.otherCompanyName }}
                  </li>
                  <li
                    :class="
                      proposal.otherCompanyRegistrationNumber
                        ? 'done'
                        : 'required'
                    "
                  >
                    <strong>شماره ثبت شرکت: </strong
                    >{{ proposal.otherCompanyRegistrationNumber }}
                  </li>
                  <li
                    :class="
                      proposal.otherCompanyNationalId ? 'done' : 'required'
                    "
                  >
                    <strong>شناسه ملی شرکت: </strong
                    >{{ proposal.otherCompanyNationalId }}
                  </li>
                </div>
                <li :class="proposal.companyProducts ? 'done' : 'required'">
                  <strong>معرفی فناوری یا محصولات شرکت: </strong><br />
                  {{ proposal.companyProducts }}
                </li>
                <li :class="proposal.companyContactInfo ? 'done' : 'required'">
                  <strong>آدرس پستی / شماره تماس/ پست الکترونیک شرکت: </strong
                  ><br />
                  {{ proposal.companyContactInfo }}
                </li>
                <li :class="proposal.companyDescription ? 'done' : 'required'">
                  <strong>توضیحات: </strong><br />
                  {{ proposal.companyDescription }}
                </li>
              </ul>
            </div>
            <ul v-else-if="proposal.commercializingType == 'accelerator'">
              <li>
                <strong class="c-purple">نام شتاب‌دهنده:</strong>

                {{ proposal.acceleratorName }}
              </li>
            </ul>
            <div v-else-if="proposal.commercializingType == 'none'">
              <div class="d-flex flex-row mb-2">
                <b-form-checkbox
                  readonly
                  v-model="proposal.commercializingObligation1"
                  @change="reactivity = !reactivity"
                ></b-form-checkbox
                ><span class="ps-2">
                  تایید میکنم با انتخاب این گزینه تا قبل از تایید درخواست توسط
                  یکی از شتاب‌دهنده‌ها یا شرکت‌های مجاز، ستاد توسعه زیست فناوری
                  هیچگونه مسئولیتی در قبال درخواست من نخواهد داشت.
                </span>
              </div>
              <div class="d-flex flex-row mb-2">
                <b-form-checkbox
                  readonly
                  v-model="proposal.commercializingObligation2"
                  @change="reactivity = !reactivity"
                ></b-form-checkbox>
                <span class="ps-2">
                  تایید میکنم با انتخاب این گزینه، کلیه اطلاعات شخصی و علمی این
                  درخواست، در اختیار شتاب‌دهنده‌ها و شرکت‌های مجاز قرار خواهد
                  گرفت تا بتوانند با بررسی اطلاعات، درخواست بنده را بررسی و
                  تایید کنند.
                </span>
              </div>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              زمان‌بندی دوره
            </h2>
            <b-table
              responsive
              small
              show-empty
              head-variant="dark"
              :items="proposal.gantData"
              :fields="timeFields"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
            </b-table>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              تعهدات
            </h2>
            <div>
              <ul>
                <li v-if="proposal.promiseArrays[0]">
                  این دوره در مدت زمان اعلام شده انجام می‌گردد و مسئولیت تاخیر
                  در انجام دوره بر عهده مجری می‌باشد. مدت زمان:
                  {{
                    proposal.gantData.length > 0
                      ? (Math.max(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.returnDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        ) -
                          Math.min(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.dispatchDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          )) /
                          3600 /
                          24 /
                          1000 +
                        " روز"
                      : ""
                  }}
                </li>
                <li v-if="proposal.promiseArrays[2]">
                  توافق بین دانشگاه و صنعت در خصوص دستاوردهای دوره وجود دارد.
                </li>
                <li v-if="proposal.promiseArrays[3]">
                  کلیه اصلاحات در موعد مقرر و طی 2 هفته توسط اینجانب انجام و در
                  سایت بارگذاری می‌گردد.
                </li>
                <li v-if="proposal.promiseArrays[4]">
                  دستاوردهای دوره مشخص است و مستندات ارائه شده است.
                </li>
                <li v-if="proposal.promiseArrays[5]">
                  بهره‌بردار نهایی دستاوردهای دوره مشخص است و مستندات ارائه شده
                  است.
                  <span v-if="proposal.commercializingType != 'none'">
                    نام بهره‌بردار:
                    <span v-if="proposal.commercializingType == 'company'">{{
                      proposal.companyId == notCompany
                        ? proposal.otherCompanyName
                        : proposal.companyName
                    }}</span>
                    <span v-else>{{
                      proposal.acceleratorId
                        ? accelerators.filter(
                            (x) => x.id == proposal.acceleratorId
                          )[0].text
                        : ""
                    }}</span>
                  </span>
                </li>
                <li v-if="proposal.promiseArrays[6]">
                  کلیه گزارش‌ها و خروجی‌ها و دستاوردها در پایان دوره به ستاد
                  زیست فناوری ارسال و تحویل داده می‌شود.
                </li>
                <li v-if="proposal.promiseArrays[7]">
                  ثبت اطلاعات در سامانه هیچ تعهدی را برای ستاد ایجاد نمی‌کند و
                  به منزله ثبت درخواست متقاضی است.
                </li>
                <li v-if="proposal.promiseArrays[8]">
                  پروپوزال رساله دکتری اینجانب مصوب شده است.
                </li>
                <li v-if="proposal.promiseArrays[9]">
                  امتحان جامع با موفقیت سپری شده است
                </li>
                <li v-if="proposal.promiseArrays[10]">
                  میزان شاخص (Hindex) اینجانب صحت دارد
                </li>
                <li v-if="proposal.promiseArrays[11]">
                  دعوتنامه معتبر از کشور مقصد دریافت شده است.
                </li>
                <li v-if="proposal.promiseArrays[12]">
                  کلیه موارد فوق مورد تایید اینجانب
                  {{
                    (proposal.researcherName ? proposal.researcherName : "-") +
                    " " +
                    proposal.researcherLastName
                  }}
                  به عنوان متقاضی و اساتید راهنما می‌باشد.
                </li>
              </ul>
            </div>
          </div>
          <hr />
        </div>
      </div>
      <!-- docx -->
      <b-tabs class="mt-8" pills v-model="tabIndex">
        <b-tab title="چکیده طرح" lazy>
          <Opportunity
            :proposal="proposal"
            :universities="universities"
            :mehvars="mehvars"
            :accelerators="accelerators"
            :companies="companies"
          />
        </b-tab>
        <b-tab title="اطلاعات تجاری‌سازی">
          <v-row class="px-4">
            <v-col md="6" cols="12">
              <h4 class="c-dark mt-2">
                نوع تجاری‌سازی:
                {{
                  proposal.commercializingType == "company"
                    ? "شرکت دانش بنیان"
                    : proposal.commercializingType == "accelerator"
                    ? "شتاب‌دهنده"
                    : "فاقد اطلاعات تجاری‌سازی می‌باشد"
                }}
              </h4>
            </v-col>
          </v-row>
          <b-card-body>
            <b-card-text>
              <div v-if="proposal.commercializingType == 'company'">
                <ul>
                  <div v-if="proposal.companyId != notCompany">
                    <li>
                      <strong class="c-purple">نام شرکت دانش بنیان: </strong
                      >{{ proposal.companyName }}
                    </li>
                    <li>
                      <strong class="c-purple">شماره ثبت شرکت: </strong
                      >{{ proposal.companyRegistrationNumber }}
                    </li>
                    <li>
                      <strong class="c-purple">شناسه ملی شرکت: </strong
                      >{{ proposal.companyNationalId }}
                    </li>
                  </div>
                  <div v-else>
                    <li>
                      <strong class="c-purple">نام شرکت دانش بنیان: </strong
                      >{{ proposal.otherCompanyName }}
                    </li>
                    <li>
                      <strong class="c-purple">شماره ثبت شرکت: </strong
                      >{{ proposal.otherCompanyRegistrationNumber }}
                    </li>
                    <li>
                      <strong class="c-purple">شناسه ملی شرکت: </strong
                      >{{ proposal.otherCompanyNationalId }}
                    </li>
                  </div>
                  <li>
                    <strong class="c-purple"
                      >معرفی فناوری یا محصولات شرکت: </strong
                    >{{ proposal.companyProducts }}
                  </li>
                  <li>
                    <strong class="c-purple"
                      >آدرس پستی / شماره تماس/ پست الکترونیک شرکت: </strong
                    >{{ proposal.companyContactInfo }}
                  </li>
                  <li>
                    <strong class="c-purple">توضیحات: </strong
                    >{{ proposal.companyDescription }}
                  </li>
                </ul>
              </div>
              <ul v-else-if="proposal.commercializingType == 'accelerator'">
                <li>
                  <strong class="c-purple">نام شتاب‌دهنده:</strong>

                  {{ proposal.acceleratorName }}
                </li>
              </ul>
              <div v-else-if="proposal.commercializingType == 'none'">
                <div class="d-flex flex-row mb-2">
                  <b-form-checkbox
                    readonly
                    v-model="proposal.commercializingObligation1"
                    @change="reactivity = !reactivity"
                  ></b-form-checkbox
                  ><span class="ps-2">
                    تایید میکنم با انتخاب این گزینه تا قبل از تایید درخواست توسط
                    یکی از شتاب‌دهنده‌ها یا شرکت‌های مجاز، ستاد توسعه زیست
                    فناوری هیچگونه مسئولیتی در قبال درخواست من نخواهد داشت.
                  </span>
                </div>
                <div class="d-flex flex-row mb-2">
                  <b-form-checkbox
                    readonly
                    v-model="proposal.commercializingObligation2"
                    @change="reactivity = !reactivity"
                  ></b-form-checkbox>
                  <span class="ps-2">
                    تایید میکنم با انتخاب این گزینه، کلیه اطلاعات شخصی و علمی
                    این درخواست، در اختیار شتاب‌دهنده‌ها و شرکت‌های مجاز قرار
                    خواهد گرفت تا بتوانند با بررسی اطلاعات، درخواست بنده را
                    بررسی و تایید کنند.
                  </span>
                </div>
              </div>
            </b-card-text>
          </b-card-body>
        </b-tab>
        <b-tab title="فایل های تکمیلی">
          <Files :files="proposal.uploadedFiles" :isLoaded="pageLoaded" />
        </b-tab>
        <b-tab title="داوری" active>
          <Review :type="'opportune'" />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
// NOTE (FUNCTION) to check validation of the email address

import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import Opportunity from "./../../components/AcceleratorOpportunity";
import Files from "./../../components/UploadedFiles";
import Review from "./../../components/AcceleratorReview";
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
const sarmadGantt = () => import("./../../components/sarmadGantt");
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    Select2, // NOTE (COMPONENT) component of select2 plugin
    Opportunity,
    Files,
    Review,
    sarmadGantt: sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
  },
  data() {
    return {
      refereeErrorHandler: false,
      oldData: [],
      expireDisable: false,
      adminToReferee: "",
      statusDictionary: [
        { en: "Done", fa: "تمام" },
        { en: "NotDone", fa: "ناتمام" },
        { en: "Expired", fa: "منقضی" },
      ],
      rejectCause: [],
      rejectOptions: [],
      infoo: "",
      promises: {},
      eduGradeOptions: [
        "--مقطع را انتخاب کنید",
        "کارشناسی",
        "کارشناسی ارشد",
        "دکتری",
        "دکتری حرفه ای",
      ],
      fileBusy: true,
      selectedStatus: null,
      selectedSituation: "",
      comments: "",
      reviewersData: [],
      reviewersFields: [],
      judgements: [],
      selectedJudgement: {},
      journalsFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام" },
        { key: "message", label: "پیام" },
        { key: "date", label: "تاریخ" },
      ],
      judgementFields: [
        { key: "index", label: "#" },
        { key: "status", label: "وضعیت" },
        { key: "referee", label: "داور" },
        { key: "decision", label: "تصمیم" },
        { key: "judgeDate", label: "تاریخ داوری" },
        { key: "description", label: "توضیحات" },
      ],
      reviewers: [],
      situationsOptions: [
        { id: 1, eng: "registered", text: "ثبت شده" },
        { id: 2, eng: "underSupervision", text: "درحال بررسی" },
        { id: 3, eng: "inviteReviewers", text: "در دست داوری" },
        { id: 4, eng: "reviewDone", text: "جمع بندی نظرات داوران" },
        { id: 5, eng: "approve", text: "پذیرش اولیه" },
        { id: 6, eng: "corrected", text: "اصلاح شده" },
        { id: 7, eng: "finalAccept", text: "تایید نهایی" },
        { id: 8, eng: "incomplete", text: "نیاز به تکمیل / اصلاح" },
        { id: 9, eng: "reject", text: "رد شده است" },
        { id: 10, eng: "declined", text: "لغو" },
      ],
      selectedReferee: "",
      adminMessage: "",
      reportItems: [],
      reportFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      fileItems: [],
      filesFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان فایل" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      haveReferee: null,
      contract: null,
      moment: moment,
      ckeckbox: {},
      show: false,
      busy: false,
      pageLoaded: false,
      initial: {},
      doi: "",
      code: {},
      source: "",
      specs: {},
      colleaguesData: [],
      serviceItems: [],
      selectedColleague: "",
      executor: {},
      proposal: {
        initialIsSupported: null,
      },
      rejectMessage: "",
      colleague: {},
      universities: [],
      mehvars: [],
      companies: [],

      zone: new Array(6).fill(false),
      tabIndex: 0,
      timeFields: [
        { key: "index", label: "ردیف" },
        { key: "dispatchDate", label: "تاریخ اعزام" },
        { key: "duration", label: "مدت زمان دوره" },
        { key: "returnDate", label: "تاریخ برگشت" },
        {
          key: "proposalSubject",
          label: "طرح هایی که در آن شرکت داشته اید",
        },
      ],
      achievitems: [],
      achievFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد" },
        { key: "operation", label: "" },
      ],
      achievFieldsDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد" },
      ],
      articlesFields: [
        { key: "index", label: "#" },
        { key: "subject", label: "عنوان" },
        { key: "releaseYear", label: "سال انتشار" },
        { key: "refrence", label: "تعداد ارجاع" },
        { key: "writersName", label: "نام نویسندگان" },
        { key: "magName", label: "نام مجله" },
        { key: "upload", label: "آپلود فایل" },
        { key: "operation", label: "" },
      ],
      articlesFieldsDoc: [
        { key: "index", label: "#" },
        { key: "subject", label: "عنوان" },
        { key: "releaseYear", label: "سال انتشار" },
        { key: "refrence", label: "تعداد ارجاع" },
        { key: "writersName", label: "نام نویسندگان" },
        { key: "magName", label: "نام مجله" },
      ],
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      drPosition: ["مربی", "استادیار", "دانشیار", "استاد‌تمام"],
      committieType: ["وزارت علوم", "وزارت بهداشت"],
      lastDegree: ["کارشناسی", "کارشناسی ارشد", "دکتری"],
      support: "",
      supportSetad: "",
      selectedMehvar: 0,
      fileFilter: "",
      taahol: "",
      DoiItem: [],
      DoiField: [
        { key: "subject", label: "عنوان" },
        { key: "mag", label: "مجله" },
        { key: "if", label: "IF" },
        { key: "year", label: "سال" },
      ],
      inventionItem: [],
      inventionField: [
        { key: "subject", label: "عنوان" },
        { key: "year", label: "سال" },
        { key: "description", label: "توضیحات" },
      ],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان فایل" },
        { key: "showName", label: "نام فایل" },
        { key: "url", label: "دریافت" },
      ],
      file: null,
      OrgCostItem: [],
      OrgCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود).",
        },
        { key: "totalPrice", label: "هزینه (ریال)" },
      ],
      OrgCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود).",
        },
        { key: "totalPrice", label: "هزینه (ریال)" },
        { key: "operation", label: "" },
      ],
      deviceCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        { key: "consumable", label: "مصرفی" },
        { key: "fund", label: "سرمایه‌ای" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد" },
        { key: "perPrice", label: "قیمت واحد به ریال" },
        { key: "totalPrice", label: "قیمت کل به ریال" },
        { key: "operation", label: "" },
      ],
      deviceCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        { key: "consumable", label: "مصرفی" },
        { key: "fund", label: "سرمایه‌ای" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد" },
        { key: "perPrice", label: "قیمت واحد به ریال" },
        { key: "totalPrice", label: "قیمت کل به ریال" },
      ],
      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
      ],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      serviceFieldsDoc: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
      ],
      tripCostField: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه (ریال)" },
        { key: "operation", label: "" },
      ],
      tripCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه (ریال)" },
      ],
      additionalFiles: {
        zero: { uploadPercentage: 0 },
        research: { uploadPercentage: 0 },
        industry: { uploadPercentage: 0 },
        agreement: { uploadPercentage: 0 },
        others1: { uploadPercentage: 0 },
        others2: { uploadPercentage: 0 },
        others3: { uploadPercentage: 0 },
      },
      acc: 0,
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
      otherFiles: new Array(10).fill({
        isUploaded: false,
      }),
      myshow: false,
      isLoaded: true,
      accelerators: [],
    };
  },

  methods: {
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = this.proposal.requestsCode + ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
    getInfo() {
      let acc = 0;
      //universities
      this.$http
        .post(
          this.baseUrl + "/setad/options/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universities = res.data;
          this.universities.push(
            new Object({
              id: this.notUniversity,
              text: "سایر دانشگاه ها",
            })
          );
          this.universities.unshift({
            id: 0,
            name: "--گزینه مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });
          acc++;
        })
        .catch((err) => {
          console.log(err);
        });
      ///////////////////////////////////////////////
      //// mehvars
      this.$http
        .post(
          this.baseUrl + "/setad/options/uniMehvars",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.mehvars = res.data;
          acc++;
        })
        .catch((err) => {
          console.log(err);
        });
      ///////////////////////////////////////////////
      // getting accelerators
      this.$http
        .post(
          this.baseUrl + "/setad/options/accelerators",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.accelerators = res.data;
          this.accelerators.forEach((x) => {
            x.text = x.name;
          });
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
      /////////////////////////////////////////////

      // companies
      this.$http
        .post(
          this.baseUrl + "/setad/options/companies",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.companies = res.data;
          this.companies.forEach((x) => {
            x.text = x.name;
          });
          this.companies.push(
            new Object({
              id: this.notCompany,
              text: "سایر شرکت ها",
            })
          );

          acc++;
        })
        .catch((err) => {
          console.log(err);
        });

      //get info
      this.$http
        .post(
          this.baseUrl + "/setad/accelerator/review/opportune/getInfo",
          {
            reviewId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.proposal = res.data.request;
          this.proposal.adminToReferee = res.data.adminToReferee;
          setTimeout(() => {
            // NOTE (m-setTimeout) to set timeout for 200 ms
            this.pageLoaded = true;
            this.isLoaded = true;
          }, 200);
          acc++;
          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  computed: {
    computedSelectedReferees() {
      let referees = this.reviewersOptions.filter(
        (x) => this.reviewers.indexOf(x.code) != -1
      );
      return referees;
    },
    computedSelectedReferees2() {
      let referees = this.reviewersOptions.filter(
        (x) => this.selectedReferee.indexOf(x.code) != -1
      );
      return referees;
    },
    computedOldData() {
      try {
        this.oldData.splice(this.oldData.length - 1, 1);
        return this.oldData;
      } catch (error) {
        return [];
      }
    },
    computedJournals() {
      if (this.proposal.history) {
        return this.proposal.history.sort((a, b) => {
          if (a.timeStamp < b.timeStamp) {
            return 1;
          }
          if (a.timeStamp > b.timeStamp) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } else return [];
    },
    computedJudgements() {
      if (this.proposal.judgements) {
        this.proposal.judgements.forEach((element) => {
          this.$set(element, "_showDetails", false);
          this.$set(element, "isActive", false);
        });

        return this.proposal.judgements;
      } else return [];
    },
    disableEditProposal() {
      if (this.selectedSituation) {
        if (this.selectedSituation == 8) {
          if (!this.proposal.description) {
            return true;
          } else return false;
        }
        if (this.selectedSituation == 7) {
          if (
            this.contract == null ||
            this.haveReferee == null ||
            !this.reportItems.length
          ) {
            return true;
          } else if (this.haveReferee && this.selectedReferee.length == 0) {
            return true;
          } else return false;
        }
        if (this.selectedSituation == 3 && this.reviewers.length == 0)
          return true;
        if (this.selectedSituation == 9 && !this.proposal.rejectionIds.length)
          return true;
        if (this.selectedSituation == 10 && !this.proposal.description)
          return true;
        return false;
      } else return true;
    },
  },
  mounted() {
    this.getInfo();
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
  },
  updated() {},
};
</script>
<style lang="scss">
.selected-referees {
  border: 1px solid grey;
  border-radius: 5px;
  margin-bottom: 10px;
  &__tags {
    border: 1px solid grey;
    border-radius: 5px;
    padding: 8px 12px;
    .tag {
      padding: 5px;
      margin: 5px;
    }
  }
}
</style>
<style lang="scss">
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.select2 {
  width: 100% !important;
}

select {
  min-width: max-content;
  width: 100%;
}

.required {
  color: red;
}

.done {
  color: green;
}

.btn-dark {
  h5 {
    color: #fff !important;
    font-size: 16px !important;
  }
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.card-header {
  background-color: #fff !important;
  border-bottom: none !important;
  padding: 0 !important;
  button {
    padding: 10px 0 !important;
  }
}
.btn-light {
  h5 {
    color: #fff !important;
    font-size: 16px !important;
  }
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  h5 {
    color: #fff !important;
    font-size: 16px !important;
  }
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  h5 {
    color: #fff !important;
    font-size: 16px !important;
  }
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  h5 {
    color: #fff !important;
    font-size: 16px !important;
  }
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}

#vs1__listbox {
  text-align: right;
  direction: rtl;
}
</style>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
</style>
